import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import ConstructionIcon from '@mui/icons-material/Construction';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import PsychologyIcon from '@mui/icons-material/Psychology';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ReceiptIcon from '@mui/icons-material/Receipt';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import { useTranslation } from "react-i18next";
import i18n from '../../../i18n';
import { motion } from "framer-motion";

export const SeamlessTools = () => {
    const { t } = useTranslation();

    const hire = [
        { id: 1, title: i18n.language === "en" ? "Insurance" : "Assurance", icon: VerifiedUserIcon },
        { id: 2, title: i18n.language === "en" ? "Appointment Scheduler" : "Planificateur de rendez-vous", icon: EditCalendarIcon },
        { id: 3, title: i18n.language === "en" ? "Job Scheduler" : "Planificateur des demandes", icon: AppRegistrationIcon },
        { id: 4, title: i18n.language === "en" ? "Job tracker" : "Suiveur de mission", icon: HowToRegIcon },
        { id: 5, title: i18n.language === "en" ? "Invoicing" : "Facturation", icon: ReceiptIcon },
        { id: 6, title: i18n.language === "en" ? "Payment System" : "Système de paiement", icon: AssuredWorkloadIcon },
        { id: 7, title: i18n.language === "en" ? "Notifications" : "Notifications", icon: NotificationAddIcon },
        { id: 8, title: i18n.language === "en" ? "Integrated Chat" : "Chat intégré", icon: MarkUnreadChatAltIcon },
        { id: 9, title: i18n.language === "en" ? "Generative Ai" : "Ai générative", icon: PsychologyIcon }
    ];

    const become = [
        { id: 1, title: "Register", icon: AppRegistrationIcon },
        { id: 2, title: "Setup payment method", icon: MonetizationOnIcon },
        { id: 3, title: "Set your hourly rates", icon: MoreTimeIcon },
        { id: 4, title: "Set your calendar availability", icon: EventRepeatIcon },
        { id: 5, title: "Provide best service possible to the client", icon: MilitaryTechIcon },
        { id: 6, title: "Get paid", icon: CreditScoreIcon }
    ];

    return (
        <Box
            sx={{
                backgroundColor: "#112240",
                paddingBottom: "40px",
                marginTop: 0,
                paddingX: { xs: 2, md: 6 },
                paddingY: 6,
                borderRadius: "20px",
                marginX: { md: 6 }
            }}
        >
            {/* Title */}
            <Typography
                fontSize={28}
                fontWeight="600"
                align="center"
                variant="h3"
                sx={{
                    mb: 4,
                    color: "#fff", // ✅ will now apply
                }}
            >
                <ConstructionIcon sx={{ color: "#fff", mr: 1 }} />
                {t('WhyWe.seemlessTolls')}
            </Typography>


            {/* Hire section */}
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                wrap="wrap"
            >
                {hire.map((step, index) => (
                    <Grid item xs={4} sm={6} md={1} key={step.id}>
                        <motion.div
                            initial={{ scale: 0 }}
                            whileInView={{ scale: 1 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                        >
                            <Card
                                sx={{
                                    borderRadius: "50%",
                                    width: 100,
                                    height: 100,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "rgba(255,255,255,0.05)",
                                    backdropFilter: "blur(6px)",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    boxShadow: "0 0 15px rgba(147, 51, 234, 0.3)",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-6px)",
                                        boxShadow: "0 0 22px rgba(100, 255, 218, 0.6)",
                                    },
                                }}
                            >
                                <CardContent
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <step.icon sx={{ color: "#64FFDA", fontSize: 25 }} />
                                    <Box sx={{ mt: 2 }}>
                                        <Typography sx={{ fontSize: 12, color: "#fff" }} align="center">
                                            {step.title}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </motion.div>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
